export default "/images/Vector.svg?b62585587315c6951c09ade3e8be46bc";